import React, { FunctionComponent } from "react";
import "./style.scss";
import point_img from "../../asserts/svg/robot_point_3.svg";


const FarewellBlock: FunctionComponent = () => {
    return <div className="FarewellBlock">
        <div className="content">
            <div className="point">
                <img src={point_img} alt="robot point" />
            </div>
            <div className="farewell">
                Timinator has proven to save our team and no doubt it will do the same for you!
            </div>
            <div className="buttons">
                <a target="_blank"  rel="noreferrer" href="https://processing.timinator.app/slack/install">
                    <button>
                        <div className="image"/>
                        <div className="text">Add to Slack</div>
                    </button>
                </a>
                <a target="_blank"  rel="noreferrer" href="https://t.me/timinator_bot">
                    <button>
                        <div className="imageTg"/>
                        <div className="text">Add to Telegram</div>
                    </button>
                </a>
            </div>
        </div>
    </div>
}

export default FarewellBlock;